export default function insertToArray(items: any[], newItems: any[], offset: number) {
  return newItems.reduce((all, item, idx) => {
    const modifiedItems = [...all]

    modifiedItems[offset + idx] = item

    return modifiedItems
  }, items)
}
